// @ts-strict-ignore
import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPayoutsTransferWallets } from 'services/UnifiedPayoutsService'

export interface TransferWalletsParams {
  walletId: string
  currencyCode: string
  walletType: string
  customerReference: string
  walletName?: string
  pageNumber?: number
  pageSize?: number
}

export const useGetPayoutsTransferWalletsQuery = (
  { walletId, currencyCode, walletType, customerReference, walletName, pageNumber, pageSize }: TransferWalletsParams,
  enabled?: boolean
) => {
  return useQuery({
    queryKey: reactQueryKeys.transferWallets({
      ...(customerReference && { customerReference }),
      ...(currencyCode && { currencyCode }),
      ...(walletType && { walletType }),
      ...(walletId && { walletId }),
      ...(walletName && { walletName }),
      ...(pageNumber !== null && pageNumber !== undefined && { pageNumber }),
      ...(pageSize !== null && pageSize !== undefined && { pageSize }),
    }),
    queryFn: () =>
      getPayoutsTransferWallets({ walletId, currencyCode, walletType, customerReference, walletName, pageNumber, pageSize }),
    enabled,
  })
}
